export const INTEGRATION_NAME_VARS = [
    '%clientname%', // CW Automate
    '$ID', // Atera
    '$s_OrganizationName', // Syncro
    '$PartnerToken', // Atera, Nable
    '$OrganizationName', // CW, Custom
    '$env:CS_PROFILE_NAME', // ATRMM
    '$env:NINJA_ORGANIZATION_NAME', // Ninja
    '#vAgentConfiguration.groupName#', // Kaseya
    '#groupName#',
    '$CompanyName', // Kaseya
    '$ClientName' // Nable
];

export const INTEGRATION_ID_VARS = [
    '%ClientExternalId%', // CW Automate
    '$ID', // Atera
    '$s_OrganizationID', // Syncro
    '$OrganizationID', // CW, Custom
    '$env:CS_PROFILE_UID', // ATRMM
    '$env:NINJA_ORGANIZATION_NAME', // Ninja
    '#vAgentConfiguration.groupName#', // Kaseya
    '#groupName#',
    '$CompanyName', // Kaseya
    '$ClientID' // Nable
];

export const INTEGRATION_NAME_ID_VARS = [
    ...INTEGRATION_NAME_VARS,
    ...INTEGRATION_ID_VARS
];
